import type { TValidatorValue } from '@alfa-bank/site-form-helpers/src/validation/models';
import type { ICity as IPlatformCity } from '@alfa-bank/site-platform-types';
import { composeValidators, validate } from '@alfa-bank/site-form-helpers/validation/utils';
import { SessionStorage } from '@alfa-bank/site-helpers-common/browser/session-storage';

import { getMaxLengthValidator } from '.';

export interface ICity extends IPlatformCity {
    ajsonId: number;
    cityDepartment?: string;
    parentCityId: number;
    prepositionalName: string;
}

/** Дефолтное значение ключа в SessionStorage, где лежат города присутствия */
const DEFAULT_CITIES_STORAGE_KEY = 'citiesOfPresenceSme';

/**
 * Проверяет валидность поля выбора города присутствия
 * @param value Значение поля
 * @param storageId Ключ SessionStorage
 * @returns Валидное ли поле
 */
export const isValidCity = (value?: string, storageId?: string): boolean => {
    if (!value) {
        return false;
    }
    const sessionStorage = new SessionStorage({ id: storageId ?? DEFAULT_CITIES_STORAGE_KEY });
    const citiesOfPresence = sessionStorage.get('citiesOfPresence');
    let cityExistsInPresenceList = 0;

    if (citiesOfPresence) {
        cityExistsInPresenceList = (citiesOfPresence as ICity[]).filter(
            ({ cityNameRus }) => cityNameRus.toLowerCase() === value.toLowerCase()
        ).length;
    }

    return Boolean(cityExistsInPresenceList);
};

export const DEFAULT_CITY_MESSAGE = 'Необходимо выбрать город из предложенного списка';

export const validateCityValue = (customMessage?: string) => (value: TValidatorValue) =>
    validate(isValidCity(value), DEFAULT_CITY_MESSAGE, customMessage);

export const validateCity = (message?: string) =>
    composeValidators(getMaxLengthValidator(50), validateCityValue(message));
